/* eslint-disable */
import React, { useEffect, useState ,Fragment} from "react";
// import { Stack, Form, Col, Row, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
    accountIntent,
  appUserActivity,
  deleteAppUserEmails,
} from "../../../redux/actions/crmActions";
import "../../crmComponents/Leadtabs.css";
import { useParams } from "react-router";
import SummaryCard from "./SummaryCard";
import moment from "moment";
import * as Icon from "react-bootstrap-icons";
import { useNavigate } from 'react-router-dom';
import { FaLinkedin } from "react-icons/fa";
import { MdOutgoingMail } from "react-icons/md";
import { LuSendHorizonal } from "react-icons/lu";
import Logo from "../../../assets/Vector.svg"
import { getGmailContent } from "../../../redux/actions/intentAction";
import { Dialog, Transition } from "@headlessui/react";
import { Menu } from '@headlessui/react'
import { INTENT_ACCOUNT } from "../../../constants/CrmActionTypes";
import { EMAIL_DATA } from "../../../constants/IntentActionTypes";

// import DeleteModal from "../../../../../shared/DeleteModal";

const IntelDetailedHistory = (props) => {
  const { id } = useParams();
  const { authToken } = props;
  const { contactId } = props;
  const navigate = useNavigate();
  const [deleteId, SetDeleteId] = useState(0);
  const [dltDialog, SetDltDialog] = useState(false);
  const [activeCards, setActiveCards] = useState([]);
  const accountDetails = useSelector((state) => state.account.account_details);
  const userDetails = useSelector((state) => state.crmLeads.userActivityDetails);
  const iAccount = useSelector((state) => state.crmLeads.intentAccount);
  const [open, setOpen] = useState(false);
  const [openLinkdin, setOpenLinkdin] = useState(false);
  const eData = useSelector((state) => state.intent.emailData);


  const uName = userDetails?.data?.response?.name

  const dispatch = useDispatch();

  // const userDetails = useSelector((state) => state.crmLeads.userActivityDetails);
  const dates = new Date();

  const getDate = (date) => {
    if (date !== "" && date !== null && date !== "0000-00-00 00:00:00") {
      let d = moment(date).format("DD");
      return d;
    }
  };

  const getMonth = (date) => {
    if (date !== "" && date !== null && date !== "0000-00-00 00:00:00") {
      const dates = new Date();
      let m = moment(date).format("MMM");
      return m.toUpperCase();
    }
  };

  const deleteEmail = () => {
    let idd = id !== undefined ? id : contactId.contact_ids[0].contact_id;
    SetDeleteId(0);
    SetDltDialog(false);
    dispatch(deleteAppUserEmails(authToken, [deleteId], idd));
  };

  const hideDialog = () => {
    SetDeleteId(0);
    SetDltDialog(false);
  };

  const openModal = (val) => {
    SetDeleteId(val.id);
    SetDltDialog(true);
  };
  
  useEffect(()=>{
    const uData = JSON.parse(localStorage.getItem("userData"));
    if(uData?.stripeData?.stripe_day_count === 0){
      navigate(`/404`);
    }
    dispatch({ type: INTENT_ACCOUNT, payload: null });
    dispatch(accountIntent(authToken, id));

  },[])


  const handleGmail = (type,aid,lid) => {
    let str = iAccount?.follow_id.toString();
    dispatch({ type: EMAIL_DATA, payload: null });
    dispatch(getGmailContent(props.authToken,aid,str,lid,type));
  };

  const composeEmail = (email, subject, message) => {
    // Construct the mailto link
    const mailtoLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
    
    // Open the Gmail compose window
    window.open(mailtoLink, '_blank');
  };


  return (
    <div className="offcanvas-body-background detailedHistory middlePiece">
      {accountDetails && (
      <div className="h-[82vh] max-sm:h-[48vh] overflow-y-auto w-full listing">
        {iAccount?.articles?.articles_report?.length > 0 ? (
          iAccount?.articles?.articles_report?.map((item, i) => {
            return (
                <main className="p-4 space-y-4 !w-full">
                <div className="bg-white px-10 py-9 shadow rounded-xl">
                  <div className="flex">
                    <div className="text-gray-400 ">{item?.human_date}</div>
                    <div className="ml-auto flex flex-end bg-[#F1F5F9] p-4 rounded-lg">
                      <LuSendHorizonal className="text-gray-400 text-lg" />
                    </div>
                  </div>
                  <div onClick={()=>window.open(item?.sourceUrl, "_blank")} className="text-xl leading-7 font-semibold mb-6 cursor-pointer">
                    {item?.new_title}
                  </div>
                  <div className="text-gray-400">Summary</div>
                  <div className="text-black">
                    <p>{item?.summary}</p>
                  </div>
                  
                  <div className="pr-6 flex pl-4 mt-8">
                    <img
                      src={Logo}
                      alt="BotIcon"
                      className="mb-auto mr-2 w-10 h-10"
                    />
                    <div className="first-left-response ml-4 !bg-[var(--brand-primary)] !w-full">
                      <Icon.CaretRightFill
                        className="left-icon-triangle-conversation"
                        color="var(--brand-primary)"
                      />
                      <p className="ai-heading text-white">Sia says</p>
                      <p className="ai-response !text-white">
                        {item?.relevance}
                      </p>
                    </div>
                  </div>

                  {<div className="mt-6">
            <div className="mb-2 text-gray-400">Talking Points</div>
           {/* {item?.action_items?.success_metrics?.length > 0 &&  <>
            <div className="list-decimal text-sm font-bold mb-1">
           B. Success Metrics
            </div>
            <div className="list-decimal text-sm ml-4">
            {item?.action_items?.success_metrics?.map((action) => {
            return (
              <li>{action}</li>
            )})}
            </div>
            </>} */}
            {item?.action_items?.clear_value_proposition?.length > 0 &&<>
            <div className="list-decimal text-sm font-bold mb-1">
           A. Value Proposition
            </div>
            <div className="list-decimal text-sm ml-4">
            {item?.action_items?.clear_value_proposition?.map((action) => {
            return (
              <li>{action}</li>
            )})}
            </div>
            </>}
            {item?.action_items?.tailored_outreach_strategy?.length > 0 && <>
            <div className="list-decimal text-sm font-bold mb-1">
           B. Outreach Strategy
            </div>
            <div className="list-decimal text-sm ml-4">
            {Array.isArray(item?.action_items?.tailored_outreach_strategy) ? item?.action_items?.tailored_outreach_strategy?.map((action) => {
            return (
              <li>{action}</li>
            )}):item?.action_items?.tailored_outreach_strategy}
            </div>
            </>}
        </div>} 

                  {item?.leads_info?.length > 0 && (
                    <>
                      <hr className="my-8" />
                      <div className="text-gray-400 mb-3">Relevant Leads</div>
                      <div className="flex flex-wrap gap-6">
                        {item?.leads_info.map((eitem) => {
                          return (
                            <div className="border-solid border-gray-100 border-2 rounded-md py-2 px-2 flex justify-between">
                              <div className="rounded-full bg-yellow-100 py-2 px-3 text-yellow-500 text-lg">
                              {eitem?.email.slice(0, 2)}
                              </div>
                              <div className="flex-col ml-3 my-auto">
                                {eitem?.first_name && (
                                  <div className="font-[600] text-sm">{`${eitem?.first_name}`}</div>
                                )}
                                <div className="font-[400] text-xs">
                                  {eitem?.email}
                                </div>
                              </div>
                              <div className="flex gap-x-2 my-auto ml-3 text-gray-400">
                                <MdOutgoingMail className="text-2xl cursor-pointer"  onClick={()=>{handleGmail("email",item?.article_id,eitem?.lead_id);setOpen(true)}}/>
                                <FaLinkedin className="text-lg my-auto cursor-pointer" onClick={()=>{handleGmail("linkedin",item?.article_id,eitem?.lead_id);setOpenLinkdin(true)}}/>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </main>
            );
          })
        ) : (
          <div className="text-[rgba(33,33,33,0.3)] py-[50px] text-[17px] font-[bolder] text-center font-add">
            <span className="flex justify-center text-[40px]">
              <Icon.Inbox />
            </span>
            No Data
          </div>
        )}
      </div>
     )} 
     <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => {setOpen(false);}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-[#f2f2f2] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:py-16 sm:px-12">
                  <div className="flex flex-col">
                    <div className="flex justify-between my-auto mb-4">
                      <div className="flex my-auto">
                        <div className="font-semibold text-lg pr-3 my-auto">
                        Smart AI-Generated email for 
                        </div>
                        <div className="rounded-full bg-yellow-100 px-3 py-2 text-yellow-500 text-sm my-auto">
                        {eData?.details?.email.slice(0, 2)}
                                </div>
                                <div className="font-semibold text-lg my-auto ml-2">{eData?.details?.email}</div>
                      </div>
                      <div className="flex">
                        <div onClick={()=>composeEmail(eData?.details?.email,eData?.details?.email_subject,eData?.details?.email_content)} className="ml-auto border-solid border-[1px] border-gray-400 flex flex-end p-2 rounded-lg mr-4">
                          <LuSendHorizonal className="text-gray-400 text-lg cursor-pointer" />
                        </div>
                        {/* <div className="ml-auto border-solid border-[1px] border-gray-400 flex flex-end p-2 rounded-lg">
                          <MdOutlineEdit  className="text-gray-400 text-lg cursor-pointer" />
                        </div> */}
                      </div>
                    </div>
                    <hr></hr>
                    <div className="font-semibold text-xl mt-2 pb-3">
                      {eData?.details?.email_subject}
                    </div>
                    <hr></hr>
                    <div className="h-[50vh] removeScroll overflow-y-auto py-3">
                      {eData?.details?.email_content}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <Transition.Root show={openLinkdin} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => {setOpenLinkdin(false);}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-[#f2f2f2] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:py-16 sm:px-12">
                  <div className="flex flex-col">
                    <div className="flex justify-between my-auto mb-4">
                      <div className="flex my-auto">
                        <div className="font-semibold text-lg pr-3 my-auto">
                        Smart AI-Generated Linkedin note for
                        </div>
                        <div className="rounded-full uppercase bg-yellow-100 px-3 py-2 text-yellow-500 text-sm my-auto">
                        {eData?.details?.email.slice(0, 2)}
                                </div>
                        <div className="font-semibold text-lg my-auto ml-2">{eData?.details?.email}</div>
                      </div>
                      <div className="flex">
                        {/* <div className="ml-auto border-solid border-[1px] border-gray-400 flex flex-end p-2 rounded-lg mr-4">
                          <LuSendHorizonal className="text-gray-400 text-lg cursor-pointer" />
                        </div> */}
                        {/* <div className="ml-auto border-solid border-[1px] border-gray-400 flex flex-end p-2 rounded-lg">
                          <MdOutlineEdit  className="text-gray-400 text-lg cursor-pointer" />
                        </div> */}
                      </div>
                    </div>
                    <hr></hr>
                    <div className="h-[50vh] removeScroll overflow-y-auto py-3">
                      {eData?.details?.message}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default IntelDetailedHistory;
